import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { InputGroup, Button, Col, Row, Card, Accordion, Modal, Table, Spinner } from "react-bootstrap";
import { TextField, MenuItem, InputAdornment, IconButton } from "@mui/material";
import { NumericFormat } from "react-number-format";
import ApiUserManager from "../../../core/api/api.userManager";
import { FormProvider, useForm, Controller } from "react-hook-form";
import _ from "lodash";
import DataGrid from "./DataGrid";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { numberRegex, tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";
import SelectComponent from "../_Components/ReactSelectComponent";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import ApiUserWallet from "../../../core/api/api.userWallet";
import SwalMessage from "../_Components/SwalMessage";

export const UsersSite = () => {
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const transformMethods = useForm({});
  let showPrice = Intl.NumberFormat("en-US");

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [status, setstatus] = useState([
    { id: 1, title: "تایید اعتبار" },
    { id: 2, title: "عدم تایید" },
  ]);
  // const [id,setId]=useState(false)
  const [show, setShow] = useState(false);
  const [showTransform, setShowTransform] = useState(false);
  const [dataForShow, setDataForShow] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        //دریافت لیست کاربران سایت
        const data = await ApiUserManager.getAllSiteUsers({
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          fromAmount: searchParams.get("fromAmount"),
          toAmount: searchParams.get("toAmount"),
          status: searchParams.get("status"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "status", type: "text" },
          { name: "fromAmount", type: "text" },
          { name: "toAmount", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmitTransform = async (data) => {
    data.type = data.type.value
    try {
      const res = await ApiUserWallet.transferWalletBalance(data)
      SwalMessage({ iSsuccess: res.succeeded, title: res.message })
      if (res.succeeded) {
        handelCloseModal()
        const submitButton = document.getElementById("submitButton")
        submitButton.click()
      }
    }
    catch {

    }
  };

  const onSubmit = async (data) => {
    if (data.status)
      data.status = data.status.value == 1
    if (!_.isEmpty(data.fromAmount) && !validateNumber(data.fromAmount)) return;
    if (!_.isEmpty(data.toAmount) && !validateNumberToAmount(data.toAmount)) return;
    data.pageNumber = getValues("pageNumber");
    tools.setPageNumber(data, searchParams, setValue);

    data.fromAmount =
      data.fromAmount && data.fromAmount.length > 0
        ? data.fromAmount.replaceAll(" ", "").replaceAll(",", "")
        : undefined;
    data.toAmount =
      data.toAmount && data.toAmount.length > 0 ? data.toAmount.replaceAll(" ", "").replaceAll(",", "") : undefined;
    // data.phoneNumberConfirmed = data.status;
    //const apiData = await ApiUserManager.getAllSiteUsers({ pageSize: data.pageSize, pageNumber: getValues("pageNumber"), globalSearch: data.globalSearch });
    const apiData = await ApiUserManager.getAllSiteUsers(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount", "phoneNumberConfirmed"]),
    );
    navigate(`/usersSite?${queryString}`);
  };

  const callBack = (index) => {
    setShow(true);
    setDataForShow(index);
  };
  const handelCloseModal = () => {
    setShow(false);
    setShowTransform()
    transformMethods.reset()
  };
  const validateNumber = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("fromAmount", { type: "manual", message: "عدد وارد شده باید کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("fromAmount");
      return true;
    }
  };

  const validateNumberToAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("toAmount", { type: "manual", message: "عدد وارد شده باید کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("toAmount");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت کاربران سایت</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست کاربران سایت</span>
          </h3>
          <div className="card-toolbar"></div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="از مبلغ"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  //prefix=" تومان "
                                  error={!!errors.fromAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumber(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.fromAmount && (
                              <div className="text-small-1 text-danger"> {errors.fromAmount.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="تا مبلغ"
                                  size="small"
                                  margin="normal"
                                  type="search"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  error={!!errors.toAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberToAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.toAmount && (
                              <div className="text-small-1 text-danger"> {errors.toAmount.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="status"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={status?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  placeholder="وضعیت"
                                  field={field}
                                  className="mt-5"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="شماره موبایل"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={(e) => {
                                    if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 11)) {
                                      e.target.value = getValues("phoneNumber")
                                      return
                                    }
                                    onChange(e)
                                  }}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-2">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid data={listData} callBack={callBack} setShowTransform={setShowTransform} setValue={transformMethods.setValue} />
              </Col>
            </form>
          </FormProvider>
        </div>
        {/* ====================================================================================================== */}
        {/*  start modal for show details of singel data ,default is hide  */}
        <Modal centered size="lg" show={show} onHide={handelCloseModal}>
          <Modal.Header closeButton className="d-flex align-items-center justify-content-between">
            <Modal.Title>نمایش اطلاعات </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mx-3">
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">نام</div>
                <div className="mt-2">{dataForShow.firstName}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">نام خانوادگی </div>
                <div className="mt-2">{dataForShow.lastName}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">نام کاربری </div>
                <div className="mt-2">{dataForShow.userName}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">ایمیل</div>
                <div className="mt-2">{dataForShow.email}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">شماره تماس </div>
                <div className="mt-2">{dataForShow.phoneNumber}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">تایید ایمیل </div>
                <div className="mt-2">{dataForShow.emailConfirmed ? "فعال" : "غیر فعال"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">تایید تلفن همراه </div>
                <div className="mt-2"> {dataForShow.phoneNumberConfirmed ? "فعال" : "غیر فعال"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">وضعیت</div>
                <div className="mt-2">{dataForShow.active ? "فعال" : "غیر فعال"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">اخرین ورود </div>
                <div className="mt-2">{dataForShow.lastLoginDate}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">زمان ایجاد </div>
                <div className="mt-2">{dataForShow.createdPersianTime} </div>
              </Col>
            </Row>
            <Row style={{ border: "1px solid #999" }} className="gap-4 rounded p-4 mx-3">
              <Col xs="12">
                <Row className="align-items-center pe-2">
                  <Col className="bg-light-info px-3 pt-3 pb-2 rounded" style={{ maxWidth: "fit-content" }}>
                    <i className="fas fa-wallet text-info fa-xl" />
                  </Col>
                  <Col className="fw-bold flex-grow-1" style={{ fontSize: 16 }}>موجودی کیف پول ها</Col>
                  <Col style={{ maxWidth: "fit-content" }}>
                    <Tippy
                      content={
                        <div className="p-2">
                          <div className="d-flex align-items-center gap-1">
                            <div className="d-flex align-items-center gap-1">
                              <i className="fas fa-credit-card text-warning fa-md" />
                              <span className="fw-bold text-warning">اعتباری:</span>
                            </div>
                            <span style={{ fontSize: 12 }}>
                              این موجودی برای کاربر غیرقابل برداشت است
                              </span>
                          </div>
                          <div className="d-flex align-items-baseline gap-1 mt-5">
                            <div style={{ top: 2 }} className="d-flex align-items-center gap-1 position-relative">
                              <i className="fas fa-money-bill-wave text-success fa-md" />
                              <span className="fw-bold text-success">نقدی:</span>
                            </div>
                            <span style={{ fontSize: 12 }}>
                              کاربر می‌تواند به ازای مبلغی که در کیف پول نقدی خود دارد درخواست برداشت وجه ثبت کند
                              </span>
                          </div>
                        </div>
                      }
                      hideOnClick={false}
                      theme="light"
                    >
                      <div style={{ borderRadius: "100%", cursor: "pointer", transform: "scale(0.8)" }} className="border px-3 border-warning text-center">
                        <i className="fa fa-info text-warning my-1" />
                      </div>
                    </Tippy>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="auto" style={{ border: "1px solid #999" }} className="rounded flex-grow-1 p-4 d-flex align-items-center gap-3 ">
                <div className="bg-light-success px-3 pt-3 pb-2 rounded">
                  <i className="fas fa-money-bill-wave text-success fa-xl" />
                </div>
                <div className="d-flex flex-column gap-1 fw-bold">
                  <span style={{ fontSize: 12 }}>نقدی:</span>
                  <div style={{ fontSize: 12 }}>
                    {showPrice.format(dataForShow?.walletRiallBalance)} <small>تومان</small>
                  </div>
                </div>
              </Col>
              <Col xs="12" md="auto" style={{ border: "1px solid #999" }} className="rounded flex-grow-1 d-flex align-items-center p-4">
                <div className="d-flex align-items-center gap-3 flex-grow-1">
                  <div className="bg-light-warning px-3 pt-3 pb-2 rounded">
                    <i className="fas fa-credit-card text-warning fa-xl" />
                  </div>
                  <div className="d-flex flex-column gap-1 fw-bold">
                    <span style={{ fontSize: 12 }}>اعتباری:</span>
                    <div style={{ fontSize: 12 }}>
                      {showPrice.format(dataForShow?.creditBalance)} <small>تومان</small>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" type="button" onClick={handelCloseModal}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
        {/* end modal */}
        {/* ================================================================================================================ */}

        {/* ====================================================================================================== */}
        {/*  start modal for show details of singel data ,default is hide  */}
        <Modal centered size="lg" show={showTransform} onHide={handelCloseModal}>
          <form onSubmit={transformMethods.handleSubmit(onSubmitTransform)}>
            <Modal.Header closeButton className="d-flex align-items-center justify-content-between">
              <Modal.Title>تبدیل موجودی کیف پول کاربر</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mx-3">
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className=" text-muted fw-bold">نام</div>
                  <div className="mt-2">{showTransform?.firstName}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className=" text-muted fw-bold">نام خانوادگی </div>
                  <div className="mt-2">{showTransform?.lastName}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className=" text-muted fw-bold">نام کاربری </div>
                  <div className="mt-2">{showTransform?.userName}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className=" text-muted fw-bold">شماره تماس </div>
                  <div className="mt-2">{showTransform?.phoneNumber}</div>
                </Col>
              </Row>
              <Row style={{ border: "1px solid #999" }} className="gap-4 rounded p-4 mx-3">
                <Col xs="12">
                  <Row className="align-items-center pe-2">
                    <Col className="bg-light-info px-3 pt-3 pb-2 rounded" style={{ maxWidth: "fit-content" }}>
                      <i className="fas fa-wallet text-info fa-xl" />
                    </Col>
                    <Col className="fw-bold flex-grow-1" style={{ fontSize: 16 }}>موجودی کیف پول ها</Col>
                    <Col style={{ maxWidth: "fit-content" }}>
                      <Tippy
                        content={
                          <div className="p-2">
                            <div className="d-flex align-items-center gap-1">
                              <div className="d-flex align-items-center gap-1">
                                <i className="fas fa-credit-card text-warning fa-md" />
                                <span className="fw-bold text-warning">اعتباری:</span>
                              </div>
                              <span style={{ fontSize: 12 }}>
                                این موجودی برای کاربر غیرقابل برداشت است
                              </span>
                            </div>
                            <div className="d-flex align-items-baseline gap-1 mt-5">
                              <div style={{ top: 2 }} className="d-flex align-items-center gap-1 position-relative">
                                <i className="fas fa-money-bill-wave text-success fa-md" />
                                <span className="fw-bold text-success">نقدی:</span>
                              </div>
                              <span style={{ fontSize: 12 }}>
                                کاربر می‌تواند به ازای مبلغی که در کیف پول نقدی خود دارد درخواست برداشت وجه ثبت کند
                              </span>
                            </div>
                          </div>
                        }
                        hideOnClick={false}
                        theme="light"
                      >
                        <div style={{ borderRadius: "100%", cursor: "pointer", transform: "scale(0.8)" }} className="border px-3 border-warning text-center">
                          <i className="fa fa-info text-warning my-1" />
                        </div>
                      </Tippy>
                    </Col>
                  </Row>
                </Col>
                <Col xs="12" md="auto" style={{ border: "1px solid #999" }} className="rounded flex-grow-1 p-4 d-flex align-items-center gap-3 ">
                  <div className="bg-light-success px-3 pt-3 pb-2 rounded">
                    <i className="fas fa-money-bill-wave text-success fa-xl" />
                  </div>
                  <div className="d-flex flex-column gap-1 fw-bold">
                    <span style={{ fontSize: 12 }}>نقدی:</span>
                    <div style={{ fontSize: 12 }}>
                      {showPrice.format(showTransform?.walletRiallBalance)} <small>تومان</small>
                    </div>
                  </div>
                </Col>
                <Col xs="12" md="auto" style={{ border: "1px solid #999" }} className="rounded flex-grow-1 d-flex align-items-center p-4">
                  <div className="d-flex align-items-center gap-3 flex-grow-1">
                    <div className="bg-light-warning px-3 pt-3 pb-2 rounded">
                      <i className="fas fa-credit-card text-warning fa-xl" />
                    </div>
                    <div className="d-flex flex-column gap-1 fw-bold">
                      <span style={{ fontSize: 12 }}>اعتباری:</span>
                      <div style={{ fontSize: 12 }}>
                        {showPrice.format(showTransform?.creditBalance)} <small>تومان</small>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mx-3">
                <Col xs="12" sm="6" className="mt-2 my-5">
                  <Controller
                    name="type"
                    control={transformMethods.control}
                    rules={{ required: "نوع انتقال را انتخاب کنید" }}
                    render={({ field: { value, onChange }, fieldState: { error } }) => (
                      <>
                        <SelectComponent
                          className="w-100"
                          placeholder="نوع انتقال"
                          options={
                            [
                              {
                                value: 0,
                                label:
                                  <div className="py-2">
                                    <span
                                      style={{ fontSize: 12 }}
                                      className="py-1 px-2 text-center mx-2 rounded bg-light-success fw-bold text-success"
                                    >
                                      <i className="fas fa-money-bill-wave text-success fa-sm ms-1" />
                                     نقدی
                                   </span>
                                    <i style={{ top: 3 }} className="fas fa-arrow-left text-black position-relative" />
                                    <span
                                      style={{ fontSize: 12 }}
                                      className="py-1 px-2 text-center mx-2 rounded bg-light-warning fw-bold text-warning"
                                    >
                                      <i className="fas fa-credit-card text-warning fa-sm ms-1" />
                                     اعتباری
                                   </span>
                                  </div>
                                ,
                                rawHtml: `
                                       <div class="py-2">
                                          انتقال از کیف پول 
                                          <span 
                                            style="font-size:12px;" 
                                            class="py-1 px-2 text-center mx-1 rounded bg-light-success fw-bold text-success"
                                          >
                                            <i class="fas fa-money-bill-wave text-success fa-sm" ></i>
                                            نقدی
                                          </span>
                                          به 
                                          <span 
                                            style="font-size:12px;" 
                                            class="py-1 px-2 text-center mx-1 rounded bg-light-warning fw-bold text-warning"
                                          >
                                            <i class="fas fa-credit-card text-warning fa-sm" ></i>
                                            اعتباری
                                          </span>
                                       </div>
                                    `,
                              },
                              {
                                value: 1,
                                label:
                                  <div className="py-2">
                                    <span
                                      style={{ fontSize: 12 }}
                                      className="py-1 px-2 text-center mx-2 rounded bg-light-success fw-bold text-success"
                                    >
                                      <i className="fas fa-money-bill-wave text-success fa-sm ms-1" />
                                     نقدی
                                   </span>
                                    <i style={{ top: 3 }} className="fas fa-arrow-right text-black position-relative" />
                                    <span
                                      style={{ fontSize: 12 }}
                                      className="py-1 px-2 text-center mx-2 rounded bg-light-warning fw-bold text-warning"
                                    >
                                      <i className="fas fa-credit-card text-warning fa-sm ms-1" />
                                     اعتباری
                                   </span>
                                  </div>
                                ,
                                rawHtml: `
                                       <div class="py-2">
                                          انتقال از کیف پول 
                                          <span 
                                            style="font-size:12px;" 
                                            class="py-1 px-2 text-center mx-1 rounded bg-light-warning fw-bold text-warning"
                                          >
                                            <i class="fas fa-credit-card text-warning fa-sm" ></i>
                                            اعتباری
                                          </span>
                                          به 
                                          <span 
                                            style="font-size:12px;" 
                                            class="py-1 px-2 text-center mx-1 rounded bg-light-success fw-bold text-success"
                                          >
                                            <i class="fas fa-money-bill-wave text-success fa-sm" ></i>
                                            نقدی
                                          </span>
                                       </div>
                                    `,
                              }
                            ]
                          }
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onChange={(e) => {
                            onChange(e);
                          }}
                        />
                        {error && <p style={{ color: "red" }}>{error.message}</p>}
                      </>
                    )}
                  />
                </Col>
                <Col xs="12" sm="6" className="mt-2 my-5">
                  <Controller
                    name="amount"
                    control={transformMethods.control}
                    render={({ field: { onChange, value, ref } }) => (
                      <NumericFormat
                        disabled={!(transformMethods.watch("type"))}
                        customInput={TextField}
                        name="amount"
                        inputRef={(el) => {
                          ref(el)
                        }}
                        size="small"
                        type="search"
                        value={value || ""}
                        className={
                          errors["amount"]
                            ? "border border-danger form-control text-center"
                            : "text-center form-control"
                        }
                        variant="outlined"
                        thousandSeparator=","
                        decimalScale="."
                        isAllowed={({ floatValue }) => {
                          if (!transformMethods.watch("type")) return false
                          else if (transformMethods.watch("type").value == 0 && floatValue !== undefined && floatValue > showTransform.walletRiallBalance) {
                            onChange(showTransform.walletRiallBalance);
                            return false;
                          }
                          else if (transformMethods.watch("type").value == 1 && floatValue !== undefined && floatValue > showTransform?.creditBalance) {
                            onChange(showTransform?.creditBalance);
                            return false;
                          }
                          return true;
                        }}
                        onValueChange={({ floatValue }) => {
                          onChange(floatValue)
                        }}
                        placeholder="مبلغ"
                        label="مبلغ"
                        onKeyDown={(e) => {
                          if (e.key === "Escape") {
                            e.stopPropagation()
                          }
                        }}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit">
                <i style={{ top: 1, transform: "scale(0.8)" }} className="fas fa-right-left fa-sm position-relative" /> ثبت
            </Button>
              <Button variant="danger" type="button" onClick={handelCloseModal}>
                <CloseIcon /> بستن
            </Button>
            </Modal.Footer>
          </form>
        </Modal>
        {/* end modal */}
        {/* ================================================================================================================ */}
      </div>
    </div>
  );
};
